import {
  fevorvertragsnummer,
  loadAndMigrateState,
  Migrator,
  migrateExtremwetterschutz,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { Vorversicherung } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';
import { migrateAssekuranztarif } from './3_migrate_assekuranztarif';
import { migrateSelbstbeteiligung } from './4_migrate_selbstbeteiligung';
import { migrateVorschaeden } from './8_migrate_vorschaeden';
import { migrateVorversicherung } from './11_migrate_vorversicherung';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: fevorvertragsnummer,
  },
  {
    toVersion: 3,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 4,
    migratorFunction: migrateSelbstbeteiligung,
  },
  {
    toVersion: 5,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 6,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 7,
    migratorFunction: migrateExtremwetterschutz,
  },
  {
    toVersion: 8,
    migratorFunction: migrateVorschaeden,
  },
  {
    toVersion: 9,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 10,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 11,
    migratorFunction: migrateVorversicherung,
  },
  {
    toVersion: 12,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
];

export const loadAndMigrateVwgState = (
  currentState: IAppState,
  loadedState: { version: number },
  vorversicherungen?: Array<Vorversicherung>,
  beibehalten?: boolean,
) =>
  loadAndMigrateState(
    currentState,
    loadedState,
    stateMigrators,
    beibehalten,
    vorversicherungen,
  );
